import React, { useState, useEffect } from "react";
import api from "api";

const BrandSelector = ({ selectedBrandId, onBrandChange }) => {
  const [brands, setBrands] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchBrands();
  }, []);

  const fetchBrands = async () => {
    try {
      setLoading(true);
      const res = await api("get", "/users?role=brand&pageSize=1000");
      setBrands(res?.users || []);
      setLoading(false);
    } catch (err) {
      console.error("Error fetching brands:", err);
      setLoading(false);
    }
  };

  return (
    <select
      value={selectedBrandId}
      onChange={(e) => onBrandChange(e.target.value)}
      disabled={loading}
      style={{
        padding: "8px 12px",
        borderRadius: "6px",
        border: "1px solid #E4E4E4",
        fontFamily: "Outfit",
        fontSize: "14px",
        color: "#1c1c1c",
        backgroundColor: "#ffffff",
        cursor: "pointer",
        minWidth: "180px",
      }}
    >
      <option value="">All Brands</option>
      {brands.map((brand) => (
        <option key={brand._id} value={brand._id}>
          {brand.name}
        </option>
      ))}
    </select>
  );
};

export default BrandSelector;
